/**
* Component: Nosto
* Corrects the discount pricing in the Nosto recommended products after they have loaded.
*/

import log from 'salvo-lite/log'
import { formatMoney } from '@shopify/theme-currency'
import { percentageSaving } from '../helpers/utils'

class Nosto {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        log.debug(this.constructor.name, 'Constructed', this)

        this._selectors = {
            price: '[data-nosto-price]',
            discount: '[data-nosto-discount]',
            priceWrapper: '[data-nosto-price-wrapper]'
        }

        this._nodeSelectors = {
            priceWrapper: null
        }
    }

    onInit () {
        this._load()
    }

    /**
     * Listens for changes in the Nosto element
     */
    _load () {
        const config = { attributes: true, childList: true, subtree: true }
        const callback = (mutationsList, observer) => {
            mutationsList.forEach(mutation => {
                if (mutation.target.classList.contains('nosto_element')) {
                    this._setNodeSelectors()
                    this._updatePrice()
                    observer.disconnect()
                }
            })
        }

        const observer = new MutationObserver(callback)

        observer.observe(this._elem, config)
    }

    /**
     * Sets node selectors after Nosto has loaded.
     */
    _setNodeSelectors () {
        this._nodeSelectors.priceWrapper = this._elem.querySelectorAll(this._selectors.priceWrapper)
    }

    /**
     * Fetches pricing from data attributes.
     */
    _updatePrice () {
        this._nodeSelectors.priceWrapper.forEach((wrapper) => {
            const price = wrapper.getAttribute('data-nosto-price')
            const discount = wrapper.getAttribute('data-nosto-discount')
            wrapper.innerHTML = this._getPriceHtml(price, discount)
        })
    }

    /**
     * Returns the pricing HTML.
     * @param {float} price
     * @param {float} discount
     */
    _getPriceHtml (price, discount) {
        const discountedPrice = (parseFloat(price) + parseFloat(discount))
        const percentageOff = percentageSaving(price, discountedPrice)
        let discountHtml = ''

        if (discount !== null) {
            discountHtml = `
            <div class="nr__product-compareprice">${formatMoney(discountedPrice * 100, window.theme.moneyFormat)}</div>
            <div class="nr__product-discount">(${percentageOff}${window.theme.strings.percentageOff})</div>`
        }

        return `<div class="nr__product-saleprice">${formatMoney(price * 100, window.theme.moneyFormat)}</div>${discountHtml}`
    }
}

export default Nosto



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Nosto.js